/**
 * Common 域：展业地域维表 API 服务（CLAUDE.md §前端 API 服务层 — 按域分目录）。
 *
 * 与后端 Pydantic 模型 src.common.dtos.legal_business_region 对齐。
 *   - GET /api/v1/legal-business-regions → 全表读（region_name 排序，只读）
 *
 * 数据源为跨平台共享维表 auto_ad_legal_business_regions（巨量 / Apple Ads 共用）；
 * 「我的资源 - 展业城市」页只读展示，地域维护不在应用侧。
 */

import { request } from "../apiClient";

/** 展业地域维表行（与后端 LegalBusinessRegionRecord 对齐）。 */
export interface LegalBusinessRegion {
  region_name: string;
  ocean_id: number[];
  apple_id: string[];
}

/** 获取全部展业地域（按 region_name 排序；空表返回 []）。 */
export async function getLegalBusinessRegions(): Promise<LegalBusinessRegion[]> {
  const data = await request<LegalBusinessRegion[] | null>(
    "/api/v1/legal-business-regions",
  );
  return data ?? [];
}
